
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface NotificationToggleProps {
  isEnabled: boolean;
  onToggle: (checked: boolean) => void;
}

const NotificationToggle = ({ isEnabled, onToggle }: NotificationToggleProps) => {
  return (
    <div className="flex items-center justify-between p-4 border rounded-lg">
      <div className="space-y-1">
        <Label className="text-base font-medium">Notifications automatiques</Label>
        <p className="text-sm text-muted-foreground">
          Activer ou désactiver l'envoi automatique des notifications d'expiration
        </p>
      </div>
      <Switch
        checked={isEnabled}
        onCheckedChange={onToggle}
      />
    </div>
  );
};

export default NotificationToggle;
